import React from "react";
import Container from "../../../../components/Container";
// import DataTable from "../../../../components/DataTable";
import DataTable from "../../DataTable";

import styles from "./MembershipHistory.module.scss";

const MembershipHistory = ({ data }) => {
  const columns = [
    { accessor: "lastUpdated", Header: "Last Updated Date" },
    { accessor: "OldGoldenId", Header: "Old Golden ID" },
    { accessor: "NewGoldenId", Header: "New Golden ID" },
    { accessor: "actor", Header: "Actor" },
    { accessor: "notes", Header: "Notes" }
  ];
  return (
    <Container className={styles.base}>
      {data ? (
        <DataTable
          columns={columns}
          data={data}
          hasHover={false}
          isStripped={false}
          getHeaderProps={() => ({
            style: {
              backgroundColor: "#fff"
            }
          })}
        ></DataTable>
      ) : (
        <div className={styles.noDetails}>{"No Membership History found"}</div>
      )}
    </Container>
  );
};

export default MembershipHistory;
